import { AddIntegrationFormDrawer } from '@modules/integrationsV2/components/AddIntegrationFormDrawer';
import { useIsIntegrationContextEnabled } from '@modules/integrationsV2/hooks';
import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';

export const SelectedAddIntegrationFormDrawer = () => {
  const isIntegrationContextEnabled = useIsIntegrationContextEnabled();

  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);
  const selectedIntegrationFormToConnect = useIntegrationsStore(
    ({ view }) => view.selectedIntegrationFormToConnect,
  );

  if (!isIntegrationContextEnabled) {
    return null;
  }

  const onDrawerClose = () => {
    dispatch({
      type: IntegrationsActionType.SET_VIEW,
      payload: {
        selectedIntegrationFormToConnect: null,
      },
    });
  };

  return (
    <AddIntegrationFormDrawer
      integrationChannel={selectedIntegrationFormToConnect?.integrationChannel}
      integrationType={selectedIntegrationFormToConnect?.integrationType}
      isOpen={!!selectedIntegrationFormToConnect}
      onDrawerClose={onDrawerClose}
    />
  );
};
